import React, { useState } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import DialogContent from "@mui/material/DialogContent";
import Footer from "./Footer";
import Selected from "./Selected";
import AssetQuantityField from "../../../../views/inventory/requests/AssetQuantityField";

const styles = {
  button: {
    minWidth: 100,
  },
};

export default function Step1({ state, onBack, onNext, onChange }) {
  const [selectedOption, setSelectedOption] = useState(state.multiplePallets);
  const [palletCount, setPalletCount] = useState(state.palletCount || 1);

  const handleOptionSelect = option => {
    if (option === "yes") {
      onChange({ multiplePallets: option });
    } else {
      onNext({ multiplePallets: option, palletCount: 1 });
    }
    setSelectedOption(option);
  };

  const handleNext = () => {
    onNext({ palletCount, multiplePallets: selectedOption });
  };

  const isNextDisabled = !selectedOption || (selectedOption === "yes" && palletCount <= 0);

  return (
    <>
      <DialogContent>
        <Box textAlign="center" mb={3} minHeight={300} display="flex" alignItems="center">
          <Box width="100%">
            <Typography color="textPrimary" mb={4}>
              Did you receive multiple pallets of this item?
            </Typography>
            <Box display="flex" justifyContent="center" gap={1}>
              <Button
                variant={selectedOption === "no" ? "contained" : "outlined"}
                onClick={() => handleOptionSelect("no")}
                sx={styles.button}
              >
                No
              </Button>
              <Button
                variant={selectedOption === "yes" ? "contained" : "outlined"}
                onClick={() => handleOptionSelect("yes")}
                sx={styles.button}
              >
                Yes
              </Button>
            </Box>
            {selectedOption === "yes" && (
              <Box mt={4}>
                <AssetQuantityField
                  quantity={palletCount}
                  onChange={setPalletCount}
                  size="small"
                  quantityProps={{
                    label: "# Pallets Received",
                    style: { minWidth: 125 },
                    InputLabelProps: {
                      shrink: true,
                    },
                  }}
                />
              </Box>
            )}
          </Box>
        </Box>
      </DialogContent>
      <Footer step={0}>
        <Selected palletCount={state.palletCount} boxesCount={state.boxesCount} />
        <Box display="flex" gap={1}>
          <Button variant="outlined" onClick={onBack} sx={styles.button}>
            Back
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={handleNext}
            disabled={isNextDisabled}
            sx={styles.button}
          >
            Next
          </Button>
        </Box>
      </Footer>
    </>
  );
}
